module.exports = __webpack_public_path__ + "assets/img/box5-img.e1a21f87.png";